// extracted by mini-css-extract-plugin
module.exports = {"page-container":"style_page-container__fBa3S","page-content":"style_page-content__HHC0f"};